import React, { Component } from 'react';
import Panel from '@common/components/panel/panel.component';
import { Row, Col } from 'react-bootstrap';
import DDadosItem from '@common/components/ddados/ddados.item';

class HeaderInformacao extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { isView, panelTitle, ddados, campos, stateSelector } = this.props;

    return (
      <Panel title={panelTitle}>
        <div className="margin-header">
          <Row>
            {campos &&
              campos.map((item, index) => (
                <Col key={index} lg={ddados[item]['BootstrapColuna']}>
                  <DDadosItem
                    name={item}
                    state={stateSelector}
                    isView={isView}
                    {...ddados[item]}
                    Desabilitado={ddados[item]['Desabilitado'] != undefined ? ddados[item]['Desabilitado'] : true}
                  />
                </Col>
              ))}
          </Row>
        </div>
      </Panel>
    );
  }
}

export default HeaderInformacao;
